import http from "./http";

const BASE = "promo.php";

/* ── List all ads (optionally filtered by page) ── */
export const getAds = async (page = "") => {
  const url = page ? `${BASE}?action=list&page=${page}` : `${BASE}?action=list`;
  const res = await http.get(url);
  return res.data;
};

/* ── Create a new ad (FormData — includes image_file) ── */
export const createAd = async (formData) => {
  const res = await http.post(`${BASE}?action=add`, formData);
  return res.data;
};

/* ── Update an existing ad (FormData — image_file optional) ── */
export const updateAd = async (formData) => {
  const res = await http.post(`${BASE}?action=update`, formData);
  return res.data;
};

/* ── Delete an ad by id ── */
export const deleteAd = async (id) => {
  const fd = new FormData();
  fd.append("id", id);
  const res = await http.post(`${BASE}?action=delete`, fd);
  return res.data;
};

/* ── Toggle active/inactive ── */
export const toggleAd = async (id) => {
  const fd = new FormData();
  fd.append("id", id);
  const res = await http.post(`${BASE}?action=toggle`, fd);
  return res.data;
};
